// Versão: 1.00
// Data..: 2026-09-24
// Casca (header + rodapé) das páginas públicas do portal.

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext.js';
import { Logo } from '../../components/Logo.js';

export function PublicShell({ children }: { children: ReactNode }) {
  const { theme, toggle } = useTheme();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header
        className="flex items-center justify-between"
        style={{
          padding: '14px 24px',
          borderBottom: '1px solid var(--border)',
          background: 'var(--surface)',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <Link to="/portal" className="flex items-center gap-2">
          <Logo height={28} />
        </Link>
        <div className="flex items-center gap-2">
          <button className="btn btn-icon btn-ghost" onClick={toggle} title="Alternar tema">
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
          <Link to="/portal/abrir" className="btn btn-sm">Abrir chamado</Link>
          <Link to="/login" className="btn btn-primary btn-sm">Entrar</Link>
        </div>
      </header>
      <main style={{ flex: 1 }}>{children}</main>
      <footer
        className="text-center text-sm text-dim"
        style={{ padding: '20px', borderTop: '1px solid var(--border)' }}
      >
        © {new Date().getFullYear()} Makweb Soluções — Portal de Suporte
      </footer>
    </div>
  );
}
